/* eslint-disable jsx-a11y/label-has-for */
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { colors } from '../../constants'
import Tooltip, { Tiptext } from '../Tooltip'
import { mediaQuery } from '../utils'
import { Button } from '../index'

const Form = styled.form`
    color: ${colors.greydark};
    font-weight: initial;
    text-align: initial;
    text-transform: none;
`

const FormHeader = styled.div`
    color: ${colors.blue};
    font-size: 18px;
    font-weight: bold;
    padding: 15px 30px;
    text-transform: none;
`

/**
 * Form Group
 * @param {object} props
 */
Form.FormHeader = ({ children, ...props }) => <FormHeader {...props}>{children}</FormHeader>

Form.FormHeader.propTypes = {
    children: PropTypes.node.isRequired,
}

const FormGroupStyle = styled.div`
    border-top: 1px solid ${colors.greylight};
    display: flex;
    padding: 15px 30px 15px;

    &:first-child {
        border-top: 0;
    }

    ${mediaQuery.mobile(`
        display: block;
    `)}
    ${({style})=>style};
`

const FormGroupTitle = styled.div`
    display: inline-block;
    font-size: 16px;
    font-weight: initial;
    margin-right: 5px;
    text-transform: none;
    width: 33%;

    ${mediaQuery.mobile(`
    display: block;
    width: 100%;
  `)}
`

const FormGroupContent = styled.div`
    display: inline-block;
    width: 100%;

    ${mediaQuery.mobile(`
    display: block;
    width: 100%;
  `)}
`

/**
 * Form Group
 * @param {object} props
 * @param {string} [props.title]
 * @param {React.ReactNode} props.children
 */
const FormGroup = ({ title, children,...props }) => (
    <FormGroupStyle {...props}>
        {title !== '' && <FormGroupTitle>{title}</FormGroupTitle>}
        <FormGroupContent>{children}</FormGroupContent>
    </FormGroupStyle>
)

Form.FormGroup = FormGroup

Form.FormGroup.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node.isRequired,
}

Form.FormGroup.defaultProps = {
    title: '',
}

const LabelWrapper = styled.label`
    display: inline-block;
    vertical-align: top;
    margin-bottom: 10px;
    ${({ noMargin }) => !noMargin && 'margin: 0 20px 10px 0;'}
`

const LabelDiv = styled.div`
    font-size: 14px;
    font-weight: initial;
    margin-bottom: 5px;
    text-transform: none;
    text-align: left;
`

const Error = styled.span`
    color: ${colors.red};
    float: right;
    font-size: 12px;
    font-weight: initial;
    line-height: 24px;
    text-transform: none;
`

const QuestionMark = styled(FontAwesomeIcon)`
    cursor: pointer;
    font-size: 12px;
    opacity: 0.4;

    &:hover {
        opacity: 0.3;
    }
`

/**
 * Form Label
 */
const LabelComponent = ({ id, label, children, description, error, noMargin, className }) => {
    const renderLabel = () => {
        if (!description) {
            return label
        }

        return (
            <Tooltip>
                {label}
                &nbsp;
                <QuestionMark icon="question-circle" />
                <Tiptext position="top">{description}</Tiptext>
            </Tooltip>
        )
    }

    return (
        <LabelWrapper htmlFor={id} noMargin={noMargin} className={className}>
            <LabelDiv noMargin={noMargin}>
                {renderLabel()}
                {error && <Error>{error}</Error>}
            </LabelDiv>
            {children}
        </LabelWrapper>
    )
}

LabelComponent.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    description: PropTypes.string,
    error: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.node,
    noMargin: PropTypes.bool,
}

LabelComponent.defaultProps = {
    className: '',
    description: null,
    error: null,
    label: '',
    noMargin: false,
}

Form.Label = LabelComponent

const PromoWrapper = styled.div`
    width: 100%;
    border-top: 1px solid ${colors.greylight};
`

Form.PromoWrapper = ({ children, ...props }) => <PromoWrapper {...props}>{children}</PromoWrapper>

const PromoButtonsSection = styled.div`
    width: 25%;
    float: right;
`

Form.PromoButtonsSection = ({ children, ...props }) => <PromoButtonsSection {...props}>{children}</PromoButtonsSection>

const PromoButton = styled(Button)`
    width: 100%;
    color: ${colors.greydark};
    background: transparent;
    border-bottom: 1px solid ${colors.greylight};
    border-radius: 0;
`
Form.PromoButton = ({ children, ...props }) => <PromoButton {...props}>{children}</PromoButton>

export default Form

export const Label = LabelComponent

export {
    FormGroup,
    FormHeader,
    PromoButton,
    PromoWrapper,
}
